import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";

// import Button from 'web/components/Button';
import Timmer from 'web/components/Timmer';
import CountdownTimer from 'web/components/TimerCustom';
import ClaimRaisePopup from '../ClaimRaisePopup';

import styled from 'styled-components'
// import Rating from '@material-ui/lab/Rating';
// import Box from '@material-ui/core/Box';
import { TrackDetail, TrackBox, DeliveredSection } from './trackDetailTypeOneStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

const TrackDetailTypeDelivered = ({ response, items, callBackTimmer }) => {
  const dispatch = useDispatch();
  // const [note, setNote] = useState('')
  const [claimRaiseId, setClaimRaiseId] = useState()
  const [claimRaiseModal, setClaimRaiseModal] = useState(false);
  const claimRaiseToggleModal = () => setClaimRaiseModal(!claimRaiseModal);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  let ratingVal = items.buyerRating
  let iteamId = items.id
  if (items.userType === "SELLER") {
    ratingVal = items.buyerRating
  } else {
    ratingVal = items.sellerRating
  }

  const [itemArr, setItemArr] = useState({ items: [] })
  // const [ratingValue, setRatingValue] = useState({
  //     id: iteamId,
  //     rating: ratingVal
  // })

  // const token = localStorage.getItem('token');
  useEffect(() => {
    let arr = []
    if (response.orders.content.length !== 0) {
      for (let i = 0; i < response.orders.content.length; i++) {

        if (items.userType === "SELLER") {
          let obj = {
            i: i,
            id: response.orders.content[i].id,
            rating: response.orders.content[i].buyerRating
          }
          arr.push(obj)
        } else {
          let obj = {
            i: i,
            id: response.orders.content[i].id,
            rating: response.orders.content[i].sellerRating
          }
          arr.push(obj)
        }

        if (i === response.orders.content.length - 1) {
          setItemArr({ items: arr })
        }
      }
    }
  }, []);

  return (<>
    <TrackDetail>
      {itemArr && itemArr.items.length !== 0 && <>
        {items.orderStatus === "CLAIM" ? <TrackBox>
          <DeliveredSection>
            <p className="claimRaised">{pageLanguageContents?.DetailedContents[4]?.Alert1}</p>
          </DeliveredSection>
        </TrackBox> :
          <TrackBox>
            {items.timeLeftToRaiseDispute !== 0 && items.userType !== "SELLER" &&
              < Timer >
                <span className="bold">{pageLanguageContents?.DetailedContents[6]?.TimeLeft}  {items.orderStatus === "CLAIM" ? <Timmer time={items.timeLeftToRaiseDispute} timerFlag={false} callBackTimmer={callBackTimmer} /> : <Timmer time={items.timeLeftToRaiseDispute} timerFlag={true} callBackTimmer={callBackTimmer} />}</span>
              </Timer>}

            <DeliveredSection>
              {/* in case delivery pricing request orders, payment intiated date is shown, for other cases just alert msg  */}
              {(items.orderDetails.title === items.id && items.userType === 'SELLER' && items?.orderStatus === 'DELIVERED' && items?.paymentCaptureTime && moment.unix(items?.paymentCaptureTime).isAfter(moment())) ? // items.orderDetails.title === items.id -> this condition is for delivery vendor pricing request orders, where order id and post name are same
                <div className="payment-initiation-date-style">
                  Payment Initiation Date : {moment(items?.paymentCaptureTime * 1000).format('MM/DD/YYYY')}
                  {/* <span style={{marginRight: '10px'}}>Payment Initiation In :</span><CountdownTimer timerEnd={moment.unix(items?.paymentCaptureTime).format('YYYY-MM-DDTHH:mm:ss.SSS')} /> */}
                </div>
                :
                <p className="greenStatus">{
                  (items.userType === "SELLER" && items.timeLeftToRaiseDispute !== 0) ?
                    'Payment pending' :
                    (items.paymentStatusDetails?.paymentStatus !== 'CAPTURED' || items.paymentStatusDetails?.paymentStatus !== 'ACH_TRANSFERRED') ?
                      'Payment is in progress' :
                      pageLanguageContents?.DetailedContents[7]?.Alert2}
                </p>
              }
            </DeliveredSection>
          </TrackBox>
        }
      </>
      }
    </TrackDetail >

    {claimRaiseId && <ClaimRaisePopup
      isOpen={claimRaiseModal}
      toggle={claimRaiseToggleModal}
      title=''
      onClickHander={(obj) => {
      }}
      content=''
      link='/'
      claimRaiseId={claimRaiseId}
    />
    }
  </>
  )
};

export default TrackDetailTypeDelivered;

const Timer = styled.div`
    margin-left: 50px;
    flex: unset !important;
    color: #00b3ff;
    >span{
        display:flex;
    }
`